export default "__VITE_ASSET__BwCCd9Ac__"